import { render, staticRenderFns } from "./DetailedInfo.vue?vue&type=template&id=575c0040&"
import script from "./DetailedInfo.vue?vue&type=script&lang=js&"
export * from "./DetailedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports